<template>
    <div id="content" class="cf site-content">
        <div id="primary" class="full-width-page">
            <main id="main" class="site-main" role="main">
                <article id="post-14" class="post-14 page type-page status-publish hentry">
                    <header class="entry-header">
                    </header>
                    <!-- .entry-header -->
                    <div class="entry-content">
                        <div id="pl-14" class="panel-layout">
                            <div id="pg-14-0" class="panel-grid panel-no-style">
                                <div id="pgc-14-0-0" class="panel-grid-cell">
                                    <div id="panel-14-0-0-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="0">
                                        <div class="textwidget">
                                            <h1><span class="" style="display:block;clear:both;height: 0px;padding-top: 10px;border-top-width:0px;border-bottom-width:0px;"></span></h1>
                                            <h1 style="text-align: center;" v-html="title"></h1>
                                            <hr>
                                            <p>&nbsp;</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="pg-14-1" class="panel-grid panel-no-style">
                                <div id="pgc-14-1-0" class="panel-grid-cell">
                                    <div id="panel-14-1-0-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="1">
                                        <div class="textwidget" v-html="content">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- .entry-content -->
                </article>
                <!-- #post-## -->
            </main>
            <!-- #main -->
        </div>
        <!-- #primary -->
    </div>
</template>
<style type="text/css" media="all" id="siteorigin-panels-layouts-head">
    /* Layout 14 */
    #pgc-14-0-0,
    #pgc-14-1-0,
    #pgc-14-2-0 {
        width: 100%;
        width: calc(100% - (0 * 30px))
    }
    #pl-14 #panel-14-0-0-0,
    #pl-14 #panel-14-1-0-0,
    #pl-14 #panel-14-2-0-0 {} #pg-14-0,
    #pg-14-1,
    #pl-14 .so-panel {
        margin-bottom: 30px
    }
    #pl-14 .so-panel:last-child {
        margin-bottom: 0px
    }
    #pg-14-0.panel-no-style,
    #pg-14-0.panel-has-style > .panel-row-style,
    #pg-14-1.panel-no-style,
    #pg-14-1.panel-has-style > .panel-row-style,
    #pg-14-2.panel-no-style,
    #pg-14-2.panel-has-style > .panel-row-style {
        -webkit-align-items: flex-start;
        align-items: flex-start
    }
    @media (max-width: 780px) {
        #pg-14-0.panel-no-style,
        #pg-14-0.panel-has-style > .panel-row-style,
        #pg-14-1.panel-no-style,
        #pg-14-1.panel-has-style > .panel-row-style,
        #pg-14-2.panel-no-style,
        #pg-14-2.panel-has-style > .panel-row-style {
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column
        }
        #pg-14-0 .panel-grid-cell,
        #pg-14-1 .panel-grid-cell,
        #pg-14-2 .panel-grid-cell {
            margin-right: 0
        }
        #pg-14-0 .panel-grid-cell,
        #pg-14-1 .panel-grid-cell,
        #pg-14-2 .panel-grid-cell {
            width: 100%
        }
        #pl-14 .panel-grid-cell {
            padding: 0
        }
        #pl-14 .panel-grid .panel-grid-cell-empty {
            display: none
        }
        #pl-14 .panel-grid .panel-grid-cell-mobile-last {
            margin-bottom: 0px
        }
    }
</style>
<script>
    import api from '../api.js'
    export
    default {
        data() {
            return {
                title: "",
                content:"",
            }
        },
        async mounted() {
            const res = await api.get('/api/article/3')
            this.title = res.data.message.item.title;
            this.content = res.data.message.item.content;
        },
        methods: {

        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Instruction.vue